import { IconBase, type IconProps } from './IconBase';

export function CrossIcon(props: IconProps) {
  return (
    <IconBase strokeWidth={2.25} {...props}>
      <path d="M6 6l12 12M18 6L6 18" />
    </IconBase>
  );
}
